import React from 'react';
import EntityAssignUsersModal from '../common/EntityAssignUsersModal';

const HomeAssignUsersModal = ({ show, home, onClose, onSaved }) => (
  <EntityAssignUsersModal
    show={show}
    entity={home}
    onClose={onClose}
    onSaved={onSaved}
    apiResource="homes"
    entityTypeLabel="home layout"
    assignmentIdField="home_id"
    exclusiveAssignment
    introText={
      <>
        Each user can only be assigned to one home layout at a time. If a user is already on
        another home, adding them here will remove them from that home and copy widgets from{' '}
        <strong>{home?.label || home?.name || 'this home'}</strong> to their personal home.
        Users not listed below keep the global default home.
      </>
    }
    emptyHint="No users assigned yet. They will see the global default home."
  />
);

export default HomeAssignUsersModal;
